





















































































































































































































































































































































































































































































































































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import ProfileTab from '@/components/member/memberCommon/accountDetailModal/ProfileTab.vue';
import JoinProjectTab from '@/components/member/memberCommon/accountDetailModal/JoinProjectTab.vue';
import { Socials, WithNumber } from '@/@types/LibraryComponent.js';
import CommonButton from '@/components/common/CommonButton.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';

@Component({
  components: {
    ProfileTab,
    JoinProjectTab,
    AccountIcon,
  },
})
export default class ProfileDetailModalBase extends Vue {
  @Prop(Boolean)
  public isOpenProfileDetailDrawer!: boolean;
  private skills: Array<object> = [
    { name: 'HTML/CSS/JavaScript', year: '8' },
    { name: 'Java', year: 11 },
    { name: 'PHP', year: 6 },
    { name: 'Laravel', year: 6 },
    { name: 'Vue.js', year: 0.5 },
    { name: 'Node.js', year: 0.5 },
    { name: 'MySQL', year: 7 },
    { name: 'AWS', year: 2 },
    { name: 'Docker', year: 0.6 },
    { name: 'Git/ GitHub', year: 3 },
  ];
  private credentials: Array<string> = [
    '基本情報技術者',
    '応用情報技術者',
    'マイクロソフトオフィススペシャリスト(MOS)',
    'データベーススペシャリスト',
  ];
  private isOpenProfileDetailDrawerEmit = this.isOpenProfileDetailDrawer;
  private rating: number = 4;
  private techniqueRating: number = 4;
  private communicationRating: number = 4;
  private understandingRating: number = 4;
  private saiyoFlag: boolean = false;
  private message = false;
  private webFlag: boolean = false;
  private tab = null;
  private rollMouseOver: boolean = false;
  private scrollY: number = 0;
  private scrollReferencePoint: number = 100;
  private isScrollLower: boolean = false;
  private isFavorite: boolean = false;
  private socials: Array<Socials> = [
    {
      icon: 'mdi-hand-heart',
      color: 'indigo',
      notDisabled: true,
      text: '参画オファー',
    },
    {
      icon: 'mdi-laptop-chromebook',
      color: 'cyan darken-1',
      notDisabled: true,
      text: 'web面談オファーして検討する',
    },
    {
      icon: 'mdi-heart',
      color: 'red lighten-3',
      notDisabled: true,
      text: '気になる',
    },
  ];
  private widthNumber: WithNumber = {
    dialog: [1200, 800],
    accountDetail: [600, 800],
    chatMessage: [600, 0],
  };

  private starColor(): 'yellow darken-1' | 'rgba(255, 255, 255, 0.8)' {
    if (this.isFavorite) {
      return 'yellow darken-1';
    }
    return 'rgba(255, 255, 255, 0.8)';
  }

  private skilChipColor(val: number): string | undefined {
    if (val < 1) {
      return 'grey lighten-2';
    } else if (10 <= val) {
      return 'pink accent-2';
    } else if (5 <= val) {
      return 'green accent-2';
    } else if (3 <= val) {
      return 'light-blue';
    } else if (1 <= val) {
      return 'amber';
    }
  }

  private clickedActionButton(notDisabled: boolean, icon: string): void {
    const selectContent:
      | {
          icon: string;
          color: string;
          notDisabled: boolean;
          text: string;
        }
      | undefined = this.socials.find((x) => x.icon === icon);
    if (selectContent) {
      if (notDisabled) {
        selectContent.notDisabled = false;
      } else {
        selectContent.notDisabled = true;
      }
    }
  }

/* ウィンドウサイズの幅決定*/
  private returnWidth(width1: number, width2: number): string {
    if (this.message) {
      if (width1 === 600) {
        return '600px';
      } else {
        return '1200px';
      }
    } else {
      if (width2 === 800) {
        return '800px';
      } else {
        return '0px';
      }
    }
  }

/* 下部ボタン選択時の色変更メソッド*/
  private buttonColor(color: string, notDisabled: boolean): 'white' | string {
    if (notDisabled) {
      return 'white';
    } else {
      return color;
    }
  }

  private mounted(): void {
    const targetElement: HTMLElement | null = document.getElementById('scrollBarTarget');
    if (targetElement) {
      targetElement.addEventListener('scroll', this.handleScroll);
    }
  }
  private handleScroll(): void {
    const targetElement: HTMLElement | null = document.getElementById('scrollBodyTarget');
    if (targetElement) {
      const clientRect: DOMRect = targetElement.getBoundingClientRect();
      this.scrollY = clientRect.top;
    }
    if (this.scrollY < this.scrollReferencePoint) {
      this.isScrollLower = true;
    } else {
      this.isScrollLower = false;
    }
  }

  private scrollIconSize(): number {
    if (this.isScrollLower) {
      return 50;
    } else {
      return 100;
    }
  }
  @Emit('onCloseProfileDetailDrawer')
  private closeProfileDetailDrawer(): void {
    this.isOpenProfileDetailDrawerEmit = false;
  }
}
